import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { SubscriptionCardV10 } from '../SubscriptionCardV10';
import styles from './SubscriptionPlanSelectorV10.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV10({ plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false }) {
    const radioGroupName = useId();

    return (
        <div className={styles.root}>
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCardV10
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        name={radioGroupName}
                        key={plan.plan}
                    />
                ))}
            </div>
            <Button
                type='pine'
                label='Get my plan'
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={cx('button', 'animation')}
                isLoading={isPending}
            />
        </div>
    );
}

SubscriptionPlanSelectorV10.propTypes = {
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool
};

export {
    SubscriptionPlanSelectorV10
};
